<template>
  <svg xmlns="http://www.w3.org/2000/svg" id="img_helper_caution" width="220" height="150" viewBox="0 0 220 150">
    <g id="Grupo_10639" data-name="Grupo 10639" transform="translate(50 30)">
      <g id="Elipse_134" data-name="Elipse 134" fill="none" stroke="#e8aa00" stroke-width="4">
        <circle cx="60" cy="60" r="60" stroke="none"/>
        <circle cx="60" cy="60" r="58" fill="none"/>
      </g>
      <path id="Caminho_3379" data-name="Caminho 3379" d="M5.275,18.645H-2.393L-4-12.85H6.878Zm-9.4,11.025a5.486,5.486,0,0,1,1.414-4.094A5.646,5.646,0,0,1,1.409,24.19a5.488,5.488,0,0,1,4.039,1.418,5.47,5.47,0,0,1,1.43,4.062,5.469,5.469,0,0,1-1.446,4.013A5.393,5.393,0,0,1,1.409,35.15a5.551,5.551,0,0,1-4.086-1.435A5.446,5.446,0,0,1-4.122,29.67Z" transform="translate(59.122 48.85)" fill="#e8aa00"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HelperExclamationSvg'
}
</script>

<style scoped>
svg g circle {
  display: block;
}
</style>
